import React, { useMemo, useState } from "react";
import VideoLightbox from "./VideoLightbox";

const tutorialsData = [
  {
    id: "1",
    title: "Introduction - Getting Started with Qemplate",
    yt: "dQw4w9WgXcQ",
  },
  {
    id: "2",
    title: "Canvas Basics and Layout | Getting Started with Qemplate",
    yt: "njX2bu-_Vw4",
  },
  {
    id: "3",
    title: "Adding and Editing Components - Getting Started with Qemplate",
    yt: "aqz-KE-bpKQ",
  },
  {
    id: "4",
    title:
      "Arrange and Layer Controls - Getting Started with Qemplate and Canvas Basics to Advanced",
    yt: "hY7m5jjJ9mM",
  },
];

const TutorialCard = ({ video, onOpen }) => {
  const thumbnail = useMemo(
    () => `https://img.youtube.com/vi/${video.yt}/hqdefault.jpg`,
    [video.yt]
  );
  return (
    <button
      onClick={() => onOpen(video)}
      className="group text-left rounded-xl overflow-hidden border border-gray-200 bg-white shadow-sm hover:shadow-md transition-shadow"
    >
      <div
        className="relative w-full bg-gray-100"
        style={{ paddingTop: "56.25%" }}
      >
        <img
          src={thumbnail}
          alt={video.title}
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="rounded-full bg-white/90 text-gray-800 px-3 py-2 shadow group-hover:scale-105 transition-transform">
            <div className="flex items-center gap-2 text-xs font-medium">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M10 15l5.19-3L10 9v6z"></path>
                <path
                  d="M21 3H3v18h18V3z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
              </svg>
              Watch
            </div>
          </div>
        </div>
      </div>
      <div className="px-3 py-2">
        <p className="text-sm font-medium text-gray-800 line-clamp-2">
          {video.title}
        </p>
      </div>
    </button>
  );
};

const TutorialSidebar = ({ isOpen, onClose }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);

  const handleOpenVideo = (video) => {
    setActiveVideo(video);
    setLightboxOpen(true);
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 z-[68] bg-black/40 transition-opacity ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={onClose}
      />

      {/* Drawer */}
      <aside
        className={`fixed right-0 z-[69] bg-white shadow-2xl border-l border-gray-200 h-[100vh] pb-20 top-0 w-[90vw] sm:w-[420px] lg:w-[500px] transform transition-transform duration-300 ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
        aria-hidden={!isOpen}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
          <h3 className="text-base font-semibold text-gray-800">Tutorials</h3>
          <button
            onClick={onClose}
            aria-label="Close tutorials"
            className="rounded-full p-2 hover:bg-gray-100 text-gray-600"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="h-full overflow-y-auto p-4 space-y-3">
          <div className="grid grid-cols-1 gap-3">
            {tutorialsData.map((t) => (
              <TutorialCard key={t.id} video={t} onOpen={handleOpenVideo} />
            ))}
          </div>
        </div>
      </aside>

      <VideoLightbox
        isOpen={lightboxOpen}
        videoId={activeVideo?.yt}
        title={activeVideo?.title}
        onClose={() => setLightboxOpen(false)}
      />
    </>
  );
};

export default TutorialSidebar;
